module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-main"
  }, [_c('div', {
    staticClass: "footer-main__container"
  }, [_c('div', {
    staticClass: "footer-main__icons"
  }, [_c('a', {
    staticClass: "footer-main__icon",
    attrs: {
      "href": "https://www.facebook.com/smiledesignorthodontics",
      "target": "_blank"
    }
  }, [_c('Icon', {
    attrs: {
      "name": "fb-white"
    }
  })], 1), _c('div', {
    staticClass: "footer-main__icon",
    on: {
      "click": function($event) {
        _vm.showModal = true
      }
    }
  }, [_c('Icon', {
    attrs: {
      "name": "map-pin-white"
    }
  })], 1), _c('a', {
    staticClass: "footer-main__icon",
    attrs: {
      "href": "tel:1-972-263-1755"
    }
  }, [_c('Icon', {
    attrs: {
      "name": "phone-white"
    }
  })], 1)]), _c('div', {
    staticClass: "footer-main__rg"
  }, [_vm._v("Online Advantage by "), _c('a', {
    staticClass: "footer-main__rg-link",
    attrs: {
      "href": "http://roostergrin.com/",
      "target": "_blank"
    }
  }, [_vm._v("Rooster Grin Media "), _c('Icon', {
    attrs: {
      "name": "rg-logo-white"
    }
  })], 1)])]), (_vm.showModal) ? _c('FooterModal', {
    on: {
      "close": function($event) {
        _vm.showModal = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6585c7d6"}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/footer/footer-main.pug
// module id = 523
// module chunks = 1